import React from "react";
import Login from "./pages/login/Login";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Users from "./pages/users/Users";
import Settings from "./pages/settings/Settings";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { MuiThemeProvider, createTheme, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "@mui/material";
import SideBar from "./components/SideBar";
import axios from "axios";
import MonitoringForm from "./pages/Monitoring/MonitoringFormPage";
import MonitoringDetailsPage from "./pages/Monitoring/MonitoringApplicationDetailPage";
import MonitoringApprovedDetailsPage from "./pages/Monitoring/MonitoringApprovedDetailPage";
import Report from "./pages/report/Report";
import MonitoringRoute from "./providers/MonitoringRoute";
import CustomTheme from "./providers/theme";
import MonitoringUpdateForm from "./pages/Monitoring/MonitoringUpdate";
import MonitoringAgreementDetailPage from "./pages/Monitoring/MonitoringAgreementDetailPage";
import MonitoringTabs from "./pages/Monitoring/MonitorigTabs";
import MonitoringCgsAgreementDetailPage from "./pages/Monitoring/MonitoringCgsAgreementDetailPage";
import MonitoringCgsStartForm from "./pages/Monitoring/MonitoringCgsStart";
import MonitoringCgsUpdateForm from "./pages/Monitoring/MonitoringCgsUpdate";
import MonitoringCgsApplicantDetailPage from "./pages/Monitoring/MonitoringCgsApplicationDetailPage";
import MonitoringCgsRoute from "./providers/MonitoringCgsRoute";
import { DialogProvider } from "./hooks/useDialog";

axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("x-access-token");
    if (token) {
      config.headers["x-access-token"] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const theme = createTheme({
  typography: {
    fontFamily: "Title",
  },
  palette: {
    primary: {
      main: "#2c5b94",
    },
    secondary: {
      main: "#142e4c",
    },
  },
});

function App() {
  const { defaultTheme } = CustomTheme();

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={defaultTheme}>
          <DialogProvider>
            <Router>
            {localStorage.getItem("x-access-token") ? (
              <div style={{ display: "flex" }}>
                <SideBar />
                <div className="app">
                  <Switch>
                    <Route exact path="/" render={() => <Redirect to="/monitoring" />} />
                    <Route exact path="/monitoring" component={MonitoringTabs} />
                    <MonitoringRoute path="/monitoring-form" component={MonitoringForm} />
                    <MonitoringRoute path="/monitoring-update-form/:id" component={MonitoringUpdateForm} />
                    <MonitoringCgsRoute path="/monitoring-update-cgs-form/:id" component={MonitoringCgsUpdateForm} />
                    <MonitoringCgsRoute path="/monitoring-start-cgs-form/:id" component={MonitoringCgsStartForm} />

                    <MonitoringRoute path="/monitoring-details/:id" component={MonitoringDetailsPage} />
                    <MonitoringCgsRoute path="/monitoring-details-cgs/:id" component={MonitoringCgsApplicantDetailPage} />

                    <MonitoringRoute path="/monitoring-approved-details/:id" component={MonitoringApprovedDetailsPage} />
                    <MonitoringRoute path="/monitoring-agreement-details/:id" component={MonitoringAgreementDetailPage} />
                    <MonitoringCgsRoute path="/monitoring-agreement-details-cgs/:id" component={MonitoringCgsAgreementDetailPage} />

                    <Route exact path="/users" component={Users} />
                    <Route exact path="/settings" component={Settings} />

                    <Route exact path="/report" component={Report} />
                  </Switch>
                </div>
              </div>
            ) : (
              <Switch>
                <Route exact path="/reset/:email/:token" component={ResetPassword} />
                <Route path="/" component={Login} />
              </Switch>
            )}
            </Router>
          </DialogProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
}

export default App;
